export const base = {
  _root: "/app"
};
